import axios from 'axios';

export async function getRoundsLeague(league_pk) {
  try {
    const res = await axios({
      method: 'GET',
      url:
        process.env.REACT_APP_API_URL +
        `/api/league/leagues/${league_pk}/rounds/`,
    });
    return res;
  } catch (error) {
    return { error: error };
  }
}

